import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";

export default function ThemeToggle({ compact = false, dataTestid = "theme-toggle" }) {
  const { isDark, toggle } = useTheme();
  return (
    <button
      onClick={toggle}
      data-testid={dataTestid}
      aria-label={`Switch to ${isDark ? "light" : "dark"} mode`}
      className={`inline-flex items-center justify-center rounded-full transition-all border ${
        compact
          ? "w-10 h-10 border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-800"
          : "px-3 h-10 gap-2 border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-800 text-sm text-slate-700 dark:text-slate-200"
      }`}
    >
      <span className="relative w-4 h-4">
        <Sun className={`absolute inset-0 w-4 h-4 transition-all ${isDark ? "opacity-0 -rotate-90 scale-0" : "opacity-100 rotate-0 scale-100"}`} />
        <Moon className={`absolute inset-0 w-4 h-4 transition-all ${isDark ? "opacity-100 rotate-0 scale-100" : "opacity-0 rotate-90 scale-0"}`} />
      </span>
      {!compact && <span>{isDark ? "Dark" : "Light"}</span>}
    </button>
  );
}
